<!--
 * @Author: your name
 * @Date: 2021-04-14 15:11:36
 * @LastEditTime: 2021-04-14 22:28:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \topboomadmin\src\views\auction\Index.vue
-->
<template>
  <div class="page">
    <PageTitle :title="title"
               :routes="routes"></PageTitle>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PageTitle from '@/components/PageTitle'
export default {
  name: 'Brand',
  components: {
    PageTitle
  },
  computed: {
    title () {
      let name = '拍卖商品管理'
      if (this.routes.length > 0) name = this.routes[this.routes.length - 1].name
      return name
    },
    ...mapState({
      routes: 'route'
    })
  },
  beforeDestroy () {
    this.$store.commit('changeRoute', null)
  },
  beforeRouteUpdate (to, from, next) {
    let path = to.path
    if (path.indexOf('/') === 0) path = path.substring(1)
    const name = to.query.id ? 'AuctionDetailAdd' : to.name
    const chineseName = {
      AuctionDetailAdd: '添加活动',
      AuctionDetail: '活动详情'
    }
    const toPage = {
      link: path,
      name: chineseName[name]
    }
    console.log(toPage)
    this.$store.commit('changeRoute', toPage)
    next()
  }
}
</script>